import React from 'react';
import './Courses.css'

const CoursePage = () => {
    return(
    <>
    <div className="section split wf-section" id='courses'>

            <div className="flex-container w-container">

                <a href="/web-development" className="visual-content vertical-flex rounded w-inline-block">
                    <div className="group">
                        <img className="image data" src={"assets/images/courses/online/coding_hover.png"} alt="" width="" height=""/>
                        <div className="group inner-padding-tablet">
                            <div className="group padding fixed-height">
                                <h3>Website Development</h3>

                                <p>In the Website Development Course, We will be using React Js, a powerful and popular library for building dynamic and interactive web applications.
                                    Overall, we will help you create professional websites for business or brands.
                                </p>

                            </div>

                        </div>
                    </div>
                    <div className="button vertical-padding left-padding c-buuton">LEARN MORE</div>

                </a>
                <a href="courses/professional-diploma-in-network-engineering.php" className="visual-content vertical-flex rounded w-inline-block">
                    <div className="group">
                        <img className="image data" src={"assets/images/courses/online/network_administration_hover.png"} alt="" width="" height=""/>
                        <div className="group inner-padding-tablet">
                            <div className="group padding fixed-height">
                                <h3>Network Administration</h3>

                                <p>
                                This course covers the basics of computer networks, including network topologies, protocols, IP addressing, subnetting, and network devices. It provides a solid understanding of how networks function.
                                </p>

                            </div>

                        </div>
                    </div>
                    <div className="button vertical-padding left-padding c-buuton">LEARN MORE</div>

                </a>
                <a href="/data-analytics" className="visual-content vertical-flex rounded w-inline-block">
                    <div className="group">
                        <img className="image data" src={"assets/images/courses/online/data_analysis_hover.png"} alt="" width="" height=""/>
                        <div className="group inner-padding-tablet">
                            <div className="group padding fixed-height">
                                <h3>Data Analytics</h3>

                                <p>
                                In Data Analytics, students learn how to analyze, interpret, and present data effectively. The course covers various topics, including statistical analysis, data visualization, data cleaning and manipulation, and machine learning algorithms.
                                </p>

                            </div>

                        </div>
                    </div>
                    <div className="button vertical-padding left-padding c-buuton">LEARN MORE</div>

                </a>
            </div><br /><br />

            <div className="flex-container w-container">

                <a href="/web-development" className="visual-content vertical-flex rounded w-inline-block">
                    <div className="group">
                        <img className="image data" src={"assets/images/courses/online/Designer_Flatline_hover.png"} alt="" width="" height=""/>
                        <div className="group inner-padding-tablet">
                            <div className="group padding fixed-height">
                                <h3>UI/UX Design</h3>

                                <p>The Diploma in Software Development program is aimed at creating software engineering professionals with the core knowledge in software development and web development as well.</p>

                            </div>

                        </div>
                    </div>
                    <div className="button vertical-padding left-padding c-buuton">LEARN MORE</div>

                </a>
                <a href="courses/professional-diploma-in-network-engineering.php" class="visual-content vertical-flex rounded w-inline-block">
                    <div className="group">
                        <img className="image data" src={"assets/images/courses/online/graphic_design_hover.png"} alt="" width="" height=""/>
                        <div className="group inner-padding-tablet">
                            <div className="group padding fixed-height">
                                <h3>Graphic Design</h3>

                                <p>The Diploma in Network Administration program is focused on Server Administration and Network Engineering. Learners will be able to understand the core concepts of Hardware, networking, server maintenance.</p>

                            </div>

                        </div>
                    </div>
                    <div className="button vertical-padding left-padding c-buuton">LEARN MORE</div>

                </a>
                <a href="courses/certificate-in-data-analytics.php" className="visual-content vertical-flex rounded w-inline-block">
                    <div className="group">
                        <img className="image data" src={"assets/images/courses/online/office.png"} alt="" width="" height=""/>
                        <div className="group inner-padding-tablet">
                            <div className="group padding fixed-height">
                                <h3>Microsoft Office Suite</h3>

                                <p>Data Analysts enable businesses to maximize the value of their data assets by using Python and Machine learning. The certificate in Data Analytics teaches students to develop new analytical methods and tools by integrating
                                    the computational, statistical, and engineering...</p>

                            </div>

                        </div>
                    </div>
                    <div className="button vertical-padding left-padding c-buuton">LEARN MORE</div>

                </a>
            </div>
            <div className="container centered padding w-container"><a href="/course-list" className="button big _280 w-button c-buuton">VIEW MORE COURSES</a></div>

        </div>
    </>
    )
}

export default CoursePage;